// extracted by mini-css-extract-plugin
export default {"loginButton":"LoginPage_loginButton__z4soU","loginWrapper":"LoginPage_loginWrapper__Q6PYe"};